import React, { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { GestureResponderEvent, StyleSheet } from 'react-native';
import { Typography, Button, Icon } from '@packages/ui/shared';
import { useNavigate } from 'react-router-dom';
import colors from '@packages/core/styles/colors';

export interface CardProps {
    buttonLink: string;
    buttonText: string;
    description: string;
    title: string;
}

const useStyles = createUseStyles({
    card: {
        border: '1px solid',
        borderColor: colors.grayThree,
        borderRadius: '4px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        height: '160px',
        justifyContent: 'space-between',
        padding: '24px',
    },
});

const styles = StyleSheet.create({
    title: {
        alignSelf: 'flex-start',
        backgroundColor: colors.blueFour,
        borderRadius: 4,
        fontSize: 11,
        fontWeight: '700',
        lineHeight: 16,
        paddingHorizontal: 8,
        paddingVertical: 2,
    },
    description: {
        fontSize: 15,
        fontWeight: '400',
    },
    button: {
        borderColor: '#1F518F',
        borderRadius: 4,
        borderWidth: 1,
        padding: 8,
        paddingLeft: 16,
    },
    titleStyle: {
        fontSize: 15,
        fontWeight: '600',
        overflow: 'hidden',
    },
});

export const DataCard: FC<CardProps> = ({ title, description, buttonText, buttonLink }) => {
    const classes = useStyles();
    const navigate = useNavigate();

    const handleNavigation = (event: GestureResponderEvent) => {
        event.preventDefault();

        const isExternal = /^(https?:\/\/|www\.|[a-zA-Z0-9-]+\.[a-zA-Z]{2,})/.test(buttonLink);

        if (isExternal) {
            const fullUrl = buttonLink.startsWith('http') ? buttonLink : `https://${buttonLink}`;
            window.open(fullUrl, '_blank', 'noopener,noreferrer');
        } else {
            navigate(buttonLink);
        }
    };

    return (
        <div className={classes.card}>
            <Typography variant="statusBadge" style={styles.title} color="blueOne">
                {title}
            </Typography>
            <Typography style={styles.description} numberOfLines={1} color="textDarkSecondary" ellipsizeMode="tail">
                {description}
            </Typography>
            <div className="d-flex justify-content-start mt-auto text-decoration-none w-auto">
                <Button
                    iconRight={<Icon name="chevron-right" color={'blueOne'} size={18} />}
                    numberOfLines={1}
                    onPress={handleNavigation}
                    style={styles.button}
                    title={buttonText}
                    titleStyle={styles.titleStyle}
                    variant="ghost-blue"
                />
            </div>
        </div>
    );
};
